export default "/images/vendor/flag-icons/flags/1x1/ps.svg?b5d637967c30e6cd616800de3c973385";